export const OPTION_DRAGGABLE_TYPE = 'field.option';
export const PARENT_OPTION_DRAGGABLE_TYPE = 'field.option.parent';
export const CHILD_OPTION_DRAGGABLE_TYPE = 'field.option.child';

const OPTION_DRAGGABLE_PREFIX = 'field.option';

type ParsedDroppableId = {
	fieldKey: string;
	parentOptionId: string;
};
// These functions help guarantee uniqueness between different types of draggables.
export const toDroppableId = (fieldKey: string, parentId: string): string =>
	`${fieldKey}#${parentId}`;
export const parseDroppableId = (droppableId: string): ParsedDroppableId => {
	const [fieldKey, parentOptionId] = droppableId.split('#');
	return { fieldKey, parentOptionId: parentOptionId || '' };
};

export const toDraggableId = (id: string): string => `${OPTION_DRAGGABLE_PREFIX}-${id}`;
export const toId = (draggableId: string): string | null =>
	draggableId.startsWith(OPTION_DRAGGABLE_PREFIX)
		? draggableId.slice(OPTION_DRAGGABLE_PREFIX.length + 1)
		: null;
